import {mapDigitizationFile} from '~/utils/mapper-digitization.js';

const apiPaths = {
  projects: '/center_conversions',
  projectDetails: '/center_conversions/:id',
  transferToStorage: '/center_conversions/:id/transfer_to_storage', //post
  transferToStorageStatus: '/center_conversions/:id/storage_transfer',

  products: '/products/digitization_upsell',
  file: '/conversion_files/:id',


};

export function useDigitizationApiService() {
  return {
    async getProjectList() {
      const data = await useConversionApi().fetch(apiPaths.projects);

      return data.center_conversions.map(mapDigitizationProject);
    },

    async getProjectDetails({id, shareToken}) {
      const data = await useConversionApi().fetch(apiPaths.projectDetails, {
        params: {
          route: {id},
          query: {
            share_token: shareToken
          }
        }
      });

      const project = data.center_conversion;
      project.isDetail = true;

      return mapDigitizationProject(project, {mapFiles: true});
    },

    async getDigitizationFile({id, shareToken}) {
      const data = await useConversionApi().fetch(apiPaths.file, {
        params: {
          route: {id},
          query: {
            share_token: shareToken
          }
        }
      });

      return mapDigitizationFile({file: data.conversion_file});
    },

    transferToStorage({id}) {
      return useConversionApi().post(apiPaths.transferToStorage, {
        params: {
          route: {id}
        }
      });
    },


    async getTransferStatus({id}) {
      const data = await useConversionApi().fetch(apiPaths.transferToStorageStatus, {
        params: {
          route: {id}
        }
      });

      return data.center_conversion_storage_transfer;
    },

    async getProjectProducts({projectSizeBytes, storageNeededBytes}) {
      const data = await useStoreApi().fetch(apiPaths.products, {
        params: {
          query: {
            project_size_bytes: Math.min(projectSizeBytes, 268435456000),//250GiB
            storage_needed_bytes: Math.max(0, storageNeededBytes)
          }
        }
      });

      return data.products;
    },

    addDigiProjectStorageToCart({product, projectId}) {
      const payload = {
        productId: product.id,
        optionValues: [
          {
            option_id: product.options[0].id,
            option_value_id: product.options[0].option_values[0].id,
            value: projectId
          }
        ],
        promotionCode: product.promotionCode
      };

      return usePricingApi().addToCart(payload);
    },

    async updateProjectCover({projectId, file}) {

      const data = await useConversionApi().put(apiPaths.projectDetails, {
        params: {
          route: {id: projectId}
        },
        body: {
          center_conversion: {
            conversion_file_id: file.id
          }
        }
      });

      return data.center_conversion;
    }
  };
}
